import moment from 'moment';

export const getDate = (date: Date | null): string => (date ? moment(date).format("YYYY-MM-DD") : "");

export const getReactTags = (tags: string[]): { id: string; text: string }[] =>
  tags.map((tag) => ({ id: tag, text: tag }));
